import { render, staticRenderFns } from "./Fare.vue?vue&type=template&id=d980c690&"
import script from "./Fare.vue?vue&type=script&lang=js&"
export * from "./Fare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports